import keyMirror from 'keymirror';

export default keyMirror({
  MLS_SEARCH_TITLE_RND: null,
  MLS_SEARCH_BACKGROUND_RND: null,
  MLS_SEARCH_FORM_RND: null,
  MLS_SEARCH_INPUT_BLOCK_RND: null,
  MLS_SEARCH_INPUT_LABEL_RND: null,
  MLS_SEARCH_INPUT_TEXT_RND: null,
  MLS_SEARCH_INPUT_SELECT_RND: null,
  MLS_SEARCH_FORM_TITLE_RND: null
});
